import { render, staticRenderFns } from "./django-support.page.vue?vue&type=template&id=7a2b208e&scoped=true"
import script from "./django-support.page.vue?vue&type=script&lang=js"
export * from "./django-support.page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a2b208e",
  null
  
)

export default component.exports